import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import PublicHeader from '../../components/PublicHeader';
import PublicFooter from '../../components/PublicFooter';
import BLOG_POSTS from './blogData';
import './PublicPages.css';

export default function BlogPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="public-page">
      <SEO
        title="Blog — Restaurant Tips, Date Night Ideas & Food Decision Hacks"
        description="The Hangrily blog: practical tips for choosing restaurants, planning date nights, group dinners, and beating food decision fatigue. Updated weekly."
        path="/blog"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'Blog',
            name: 'Hangrily Blog',
            description: 'Tips for choosing restaurants, planning date nights, and beating food decision fatigue.',
            url: 'https://hangrily.app/blog',
            publisher: { '@type': 'Organization', name: 'Hangrily', url: 'https://hangrily.app' }
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://hangrily.app' },
              { '@type': 'ListItem', position: 2, name: 'Blog', item: 'https://hangrily.app/blog' }
            ]
          }
        ]}
      />
      <PublicHeader />

      <main className="public-main">
        <div className="public-container">
          <div className="blog-hero">
            <h1 className="blog-hero-title">The Hangrily Blog</h1>
            <p className="blog-hero-subtitle">Tips, guides, and science-backed advice for choosing where to eat — solo, with your partner, or with your crew.</p>
          </div>

          <div className="blog-grid">
            {BLOG_POSTS.map((post) => (
              <Link to={`/blog/${post.slug}`} key={post.slug} className="blog-card">
                <div className="blog-card-image" style={{ backgroundImage: `url(${post.image})` }}>
                  <span className="blog-card-category">{post.category}</span>
                </div>
                <div className="blog-card-body">
                  <h2 className="blog-card-title">{post.title}</h2>
                  <p className="blog-card-desc">{post.description}</p>
                  <div className="blog-card-meta">
                    <span>{post.date}</span>
                    <span className="blog-meta-dot">&middot;</span>
                    <span>{post.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="blog-cta-section">
            <h2>Stop arguing about dinner.</h2>
            <p>Hangrily picks a restaurant everyone agrees on in under 2 minutes.</p>
            <Link to="/try" className="btn btn-primary btn-lg">Try Hangrily Free</Link>
          </div>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
}
